"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareSegments = exports.validateAndParse = exports.semver = void 0;
exports.semver = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;
var validateAndParse = function (version) {
    if (typeof version !== 'string') {
        throw new TypeError('Invalid argument expected string');
    }
    var match = version.match(exports.semver);
    if (!match) {
        throw new Error("Invalid argument not valid semver ('".concat(version, "' received)"));
    }
    match.shift();
    return match;
};
exports.validateAndParse = validateAndParse;
var isWildcard = function (s) { return s === '*' || s === 'x' || s === 'X'; };
var tryParse = function (v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? v : n;
};
var forceType = function (a, b) {
    return typeof a !== typeof b ? [String(a), String(b)] : [a, b];
};
var compareStrings = function (a, b) {
    if (isWildcard(a) || isWildcard(b))
        return 0;
    var _a = forceType(tryParse(a), tryParse(b)), ap = _a[0], bp = _a[1];
    if (ap > bp)
        return 1;
    if (ap < bp)
        return -1;
    return 0;
};
var compareSegments = function (a, b) {
    for (var i = 0; i < Math.max(a.length, b.length); i++) {
        var r = compareStrings(a[i] || '0', b[i] || '0');
        if (r !== 0)
            return r;
    }
    return 0;
};
exports.compareSegments = compareSegments;
//# sourceMappingURL=utils.js.map